import { ColDef } from '@ag-grid-community/core';

import { Utils } from '@shared/utils/utils';

import { MAP_FREQUENCY_TITLE_BY_TYPE } from '../const/frequency.const';
import { GridRowData } from '../types/site-budget-grid-row';

export const ignoreCompareForNewRows: (
  strategy: 'frequency' | 'number' | 'text'
) => ColDef<GridRowData>['comparator'] = (strategy) => (valA, valB, nodeA, nodeB) => {
  const aIsNew = !nodeA?.data?.paymentScheduleId;
  const bIsNew = !nodeB?.data?.paymentScheduleId;

  if (aIsNew || bIsNew) return 0;

  if (strategy === 'text') {
    return Utils.alphaNumSort(valA, valB);
  }

  if (strategy === 'frequency') {
    return Utils.alphaNumSort(
      MAP_FREQUENCY_TITLE_BY_TYPE.get(valA) || '',
      MAP_FREQUENCY_TITLE_BY_TYPE.get(valB) || ''
    );
  }

  return valA - valB;
};
